export const DownloadBlockSchema = (props) => {
  return {
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['download'],
      },
    ],
    properties: {
      download: {
        title: 'Download',
        widget: 'object_browser',
        widgetOptions: {
          pattern_options: { selectableTypes: ['File', 'Image'] },
        },
        mode: 'multiple',
        return: 'multiple',
        allowExternals: false,
      },
    },
  };
};

export default DownloadBlockSchema;
